import ArrowBackIcon       from '@/assets/icons/ArrowBackIcon';
import { Box }             from '@chakra-ui/react';
import { Link }            from 'react-router-dom';
import { Text }            from '@chakra-ui/react';
import { useLocation }     from 'react-router-dom';
import { useTranslation }  from 'react-i18next';

interface IBackButtonProps {
	to?: string;
}

const BackButton = (props: IBackButtonProps) => {
	const { to } = props;
	const { t, i18n } = useTranslation();
	const location = useLocation();
	const from = (location.state as { from?: { pathname: string } })?.from?.pathname || `/${i18n.language}/`;

	return (
		<Box
			display="flex"
			alignItems="center"
			gap="10px"
			lineHeight="0px"
		>
			<ArrowBackIcon size="md" />
			<Link to={to || `/${i18n.language}/${from.split('/')[2]}`}>
				<Text
					fontWeight={550}
					textDecoration="underline"
				>
					{t('app.back')}
				</Text>
			</Link>
		</Box>
	)
}

export default BackButton